<template>
  <a
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    class="SpecialFeatureCard"
  >
    <div class="cardContent">
      <img :src="image" alt="" />
      <div class="clamp">
        <div v-if="description">{{ description }}</div>
      </div>
      <div v-if="showPr" class="pr">PR</div>
    </div>
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SpecialFeatureCard',
  props: {
    image: {
      type: String,
      default: require('@/assets/images/common/noimg.jpg')
    },
    description: String,
    url: String,
    path: String,
    showPr: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.cardContent {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border: 0.5px solid var.$color-border-gray;
  background-color: var.$color-white;

  img {
    width: 100%;
  }
}
.clamp {
  height: auto;
  font-size: 13px;
  margin: 15px 20px 13px 20px;
  line-height: 1.46;

  @include mixins.media() {
    margin: 12px 20px 10px 20px;
  }
}

.pr {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 11px;
  background-color: rgba(58, 58, 58, 0.8);
  color: #fff;
  font-size: 13px;
  line-height: 13px;

  @include mixins.mediaMax('sm') {
    padding: 4px 8px;
    font-size: 11px;
    line-height: 11px;
  }
}
</style>
